// FILE: bold-sc-helpers.js
(function () {
  const _toStr = v => (v == null ? '' : String(v));
  const _toKey = s => _toStr(s).trim().toLowerCase();
  const _isFilled = item => {
    const v = item?.value;
    return !(v == null || (typeof v === 'string' && !v.trim()));
  };
  const _isRequired = item => !(item?.required === false) && !item?.disabled;

  const Helpers = {
    findOption(model, nameOrId) {
      const k = _toKey(nameOrId);
      return (Array.isArray(model) ? model : []).find(it => 
        _toKey(it.id) === k || _toKey(it.name) === k || _toKey(it.rawName) === k
      ) || null;
    },
    
    getValue(model, nameOrId) {
      return Helpers.findOption(model, nameOrId)?.value ?? null;
    },

    groupByStep(model) {
      const groups = {};
      (Array.isArray(model) ? model : []).forEach(it => {
        const gid = _toStr(it.groupId || '0');
        (groups[gid] || (groups[gid] = [])).push(it);
      });
      return groups;
    },

    isStepComplete(model, stepIndexOrId) {
      const items = Helpers.getStep(model, stepIndexOrId);
      if (!items.length) return true;
      // Check every required item is filled
      return items.every(it => !_isRequired(it) || _isFilled(it));
    },

    getStep(model, stepId) {
      return Helpers.groupByStep(model)[_toStr(stepId)] || [];
    },

    getSafeText(el) { 
      if (!el) return ''; 
      const clone = el.cloneNode(true); 
      Array.from(clone.children).forEach(child => child.remove()); 
      let text = clone.textContent.replace(/\*/g, '').trim(); 
      return text.trim(); 
    },

    // Canonical key for cache/indexing (strip *, normalize spaces)
    canonicalOptionKey(label) {
      return String(label || '')
        .replace(/\*/g, '')      // remove asterisks
        .replace(/\s+/g, ' ')    // collapse whitespace
        .trim();
    },


    // Strips Bold inline price annotations and 'Pattern ' prefix from option values.
    sanitizeLetterValue(value) {
      return String(value || '')
        .replace(/\s*\[.*?\]/g, '')
        .replace(/\s*\(\s*[\+\$][^)]*\)/g, '')
        .replace(/\s*\+\s*\ \d+(\.\d{2})?\s*$/, '')
        .replace(/^Pattern\s?/, '')
        .trim();
    },

    // Abbreviates common garment color words for compact display.
    sanitizeGarmentLabel(value) {
      return String(value || '')
        .replace(/\bAntique\b/g, 'Antq.')
        .replace(/\bHeather\b/g, 'Hthr.')
        .trim();
    },

    // Abbreviates size labels for compact cart display.
    sanitizeSizeAbbrev(value) {
      const clean = String(value || '').replace(/\s*\+\s*\ \d+(\.\d{2})?\s*$/, '').trim();
      const t = clean.toLowerCase().replace(/[\s-]/g, '');
      const map = { xs:'XS',xsmall:'XS',s:'SM',sm:'SM',small:'SM',m:'MD',med:'MD',md:'MD',medium:'MD',l:'LG',lg:'LG',large:'LG',xl:'XL',xlarge:'XL','1x':'XL','2xl':'2XL',xxl:'2XL','3xl':'3XL',xxxl:'3XL','4xl':'4XL','5xl':'5XL' };
      return map[t] || clean;
    },

    normalizeSizeLabel(text) {
        if (!text) return '';

        // Ensure string
        let cleaned = String(text);

        // Remove price add-ons: "(+ $5)", "[+ $5.00]", " (+$10)" etc.
        cleaned = cleaned
            .replace(/\s?(\(|\[)\+\s?\$\d*\.?\d*(\)|\])/gi, '')
            .trim();

        // Normalize for the switch
        const t = cleaned
            .toLowerCase()
            .replace(/\s+/g, '')  // remove spaces
            .replace(/-/g, '');   // remove dashes

        switch (t) {
            // X-Small
            case 'xs':
            case 'xsmall':
            case 'xsm':
            return 'X-Small';

            // Small
            case 's':
            case 'sm':
            case 'small':
            return 'Small';

            // Medium
            case 'm':
            case 'med':
            case 'md':
            case 'medium':
            return 'Medium';

            // Large
            case 'l':
            case 'lg':
            case 'large':
            return 'Large';

            // X-Large
            case 'xl':
            case 'xlarge':
            case 'xlg':
            case '1x':
            return 'X-Large';

            // 2X-Large
            case '2xl':
            case 'xxl':
            case '2x':
            case '2xlarge':
            return '2X-Large';

            // 3X-Large
            case '3xl':
            case 'xxxl':
            case '3x':
            case '3xlarge':
            return '3X-Large';

            // 4X-Large
            case '4xl':
            case 'xxxxl':
            case '4x':
            case '4xlarge':
            return '4X-Large';

            // 5X-Large
            case '5xl':
            case 'xxxxxl':
            case '5x':
            case '5xlarge':
            return '5X-Large';

            default:
            // If we don't recognize it, return the cleaned label
            return cleaned;
        }
    },
  };

  // Expose global
  window.HubOptionsHelpers = Helpers;
  // Attempt attach to adapter if exists
  try {
    const hub = document.querySelector('bold-sc-adapter');
    if (hub) {
      hub.facade = hub.facade || {};
      hub.facade.helpers = Helpers;
    }
  } catch (_) {}
})();